// extracted by mini-css-extract-plugin
export default {"galery":"ProductDetails_galery__Qcyo4","galerydetails":"ProductDetails_galerydetails__0oI8A"};